import { render } from "./opted-out-parent-preview.vue?vue&type=template&id=dff7a10e&scoped=true"
import script from "./opted-out-parent-preview.vue?vue&type=script&lang=js"
export * from "./opted-out-parent-preview.vue?vue&type=script&lang=js"

import "./opted-out-parent-preview.vue?vue&type=style&index=0&id=dff7a10e&lang=scss&scoped=true"

import exportComponent from "/home/node/ks-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dff7a10e"]])

export default __exports__